// @ts-nocheck
import platform from '../_utils/platform';
function base642Blob(base64) {
    const arr = base64.split(',');
    const mime = (arr[0].match(/:(.*?);/) || ['png'])[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}
const chooseLocalImage = ({ count, success, complete }) => {
    const res = {
        errMsg: 'chooseImage:ok',
        tempFilePaths: [],
        tempFiles: []
    };
    const chooseImageInput = document.createElement('input');
    chooseImageInput.setAttribute('type', 'file');
    if (count > 1) {
        chooseImageInput.setAttribute('multiple', 'multiple');
    }
    chooseImageInput.setAttribute('accept', 'image/*');
    chooseImageInput.setAttribute('style', 'position: fixed; top: -4000px; left: -3000px; z-index: -300;');
    document.body.appendChild(chooseImageInput);
    let chooseImageCallback;
    const chooseImagePromise = new Promise((resolve) => {
        chooseImageCallback = resolve;
    });
    const mouseEvents = document.createEvent('mouseEvent');
    mouseEvents.initEvent('click', true, true);
    if (chooseImageInput) {
        chooseImageInput.dispatchEvent(mouseEvents);
        chooseImageInput.onchange = (e) => {
            if (e.target) {
                const arr = [...e.target.files];
                arr &&
                    arr.forEach((item) => {
                        const blob = new Blob([item], {
                            type: item.type
                        });
                        const url = URL.createObjectURL(blob);
                        res.tempFilePaths.push(url);
                        res.tempFiles.push({ path: url, size: item.size, type: item.type });
                    });
                typeof success === 'function' && success(res);
                typeof complete === 'function' && complete(res);
                chooseImageCallback(res);
            }
        };
    }
    document.body.removeChild(chooseImageInput);
    return chooseImagePromise;
};
const chooseImage = ({ count = 1, sourceType = ['album', 'camera'], sizeType = ['original', 'compressed'], success, complete }) => {
    if (process.env.NODE_ENV === 'development' || !platform.isWx() || platform.isWxDevTool()) {
        // 微信JSSDK的选择图片功能本地调试没法使用，所以写个方法专门用来做本地调试
        return chooseLocalImage({
            count,
            success,
            complete
        });
    }
    else {
        return new Promise((resolve) => {
            window.wx.chooseImage({
                count,
                sourceType,
                sizeType,
                success: (res) => {
                    const tempFilePaths = [];
                    res.localIds.forEach((localId, index) => {
                        window.wx.getLocalImgData({
                            localId,
                            success: (res1) => {
                                const localData = res1.localData;
                                let imageBase64 = '';
                                if (localData.indexOf('data:image') === 0) {
                                    // 苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
                                    imageBase64 = localData;
                                }
                                else {
                                    // 此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
                                    // 此时一个正常的base64图片路径就完美生成赋值到img的src中了
                                    imageBase64 = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
                                }
                                const imageUrl = URL.createObjectURL(base642Blob(imageBase64));
                                tempFilePaths.push(imageUrl);
                                if (index === res.localIds.length - 1) {
                                    resolve({
                                        tempFilePaths
                                    });
                                }
                            },
                            fail: (err) => {
                                throw err;
                            }
                        });
                    });
                },
                fail: (err) => {
                    throw err;
                }
            });
        });
    }
};
export default chooseImage;
